export default "/images/bfe45af8e9919150271ed81cdf5a6895.avif";